import { StateSchema } from 'app/providers/StoreProvider';

export const getPropertyItem = (state: StateSchema) => state.propertyItem?.data;
export const getPropertyId = (state: StateSchema) =>
    state.propertyItem?.data?.id;
export const getPropertyCatalogId = (state: StateSchema) =>
    state.propertyItem?.data?.catalogId;
export const propertyItemLoading = (state: StateSchema) =>
    state.propertyItem?.isLoading;
